import { get } from 'lodash';
import { modifyAlpha } from '../../../../utils/modifyColour';

const styles = ({ color, fontSize, typography }) => ({
  addBtn: {
    float: 'right',
    marginBottom: 10,
  },
  assistText: {
    marginLeft: 4,
  },
  assistTextIcon: {
    display: 'flex',
  },
  helpIcon: {
    color: color.primaryButtonBackground,
    marginLeft: 6,
    marginTop: 3,
    height: 16,
    width: 16,
  },
  assistTextContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  helpIconContainer: {
    display: 'flex',
  },
  cautionMessageDiv: {
    backgroundColor: `${modifyAlpha('#E47226', 0.2)}`,
    border: '1px solid #E47226',
    marginTop: 8,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 6,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 6,
    width: 'fit-content',
  },
  missingTemplatesIcon: {
    verticalAlign: 'middle',
    marginRight: 6,
  },
  moveBtn: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  nameFieldContainer: {
    marginBottom: '0 !important',
    marginTop: '0px !important',
    width: '50%',
  },
  pageClass: {
    margin: '0 0',
  },
  pageFilterAndSortClass: {
    alignItems: 'end',
    marginBottom: 20,
    marginLeft: 36,
    marginRight: 36,
    marginTop: 0,
    padding: 0,
    width: 'auto',
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
  unavailableTemplate: {
    color: get(color, 'link'),
  },
});
  
export default styles;
